import styled from 'styled-components';

export const ControllerContainer = styled.div`
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 24px 16px;
  font-family: 'Open Sans', sans-serif;
`;

export const ControllerSettingsContainer = styled.div`
  width: 380px;
  border-radius: 8px;
  background: var(--light-primary-background-color, #fff);
  padding: 18px 24px 18px 24px;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--light-primary-text-color, #323338);
    font-family: Roboto;
    font-size: 20px;
    font-weight: bold;

    .icon {
      cursor: pointer;
    }
  }

  .content {
    margin: 30px 0px 30px 0px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .footer {
    display: flex;
    flex-direction: row-reverse;
    gap: 15px;

    button {
      height: 32px;
      width: 61px;
      border-radius: 4px;
      cursor: pointer;

      &.danger {
        background-color: #d83a52;
        color: white;
        border: none;
      }

      &.info {
        background-color: #0173ea;
        color: white;
        border: none;
      }

      &.outlined {
        background-color: white;
        border: 0.5px solid grey;
      }
    }
  }
`;
